<script lang="ts">
  import { Chip, type FacetValue } from "../facet-value";
  import type { FacetValueGroup, FacetValueGroupOptions } from "./type.ts";

  interface Props extends FacetValueGroup, FacetValueGroupOptions {}

  let { values = [], title, item = chip, containsRanges = false, gridCellMinSize = "79" }: Props = $props();
</script>

{#snippet chip(facetValue: FacetValue)}
  <Chip {...facetValue} />
{/snippet}

{#if values.length > 0}
  <div>
    {#if title}<h4>{title}</h4>{/if}
    <ul
      class={[{ "hc_facetValueGroup--ranges": containsRanges }, "hc_facetValueGroup--ocRanges"]}
      style="--grid-cell-min-size: {gridCellMinSize}px"
    >
      {#each values as facetValue (facetValue.title)}
        <li>{@render item(facetValue)}</li>
      {/each}
    </ul>
  </div>
{/if}

<style lang="scss">
  h4 {
    margin-bottom: var(--oc-semantic-spacing-75);
    font: var(--oc-semantic-font-copy-75);
    text-transform: uppercase;
    color: var(--oc-semantic-color-text-secondary);
  }

  ul {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(auto-fill, var(--grid-cell-width, minmax(4rem, 1fr)));
    gap: var(--oc-semantic-spacing-50) var(--oc-semantic-spacing-50);

    --label-width: minmax(0, 100%);
  }

  .hc_facetValueGroup--ranges {
    margin-bottom: var(--oc-semantic-spacing-25);
    grid-template-columns: repeat(auto-fill, minmax(var(--grid-cell-min-size), 1fr));
    column-gap: var(--oc-semantic-spacing-50);
  }
</style>
